<template>
    <div class="p-2 text-dark">
        <!-- Khi không có dữ liệu -->
        <div v-if="!testHistoryData || testHistoryData.length === 0" class="d-flex justify-content-center py-5">
            <div class="text-muted h5 mb-2">Chưa có lịch sử kiểm tra</div>
        </div>

        <!-- Khi có dữ liệu -->
        <div v-else class="table-responsive overflow-auto">
            <table class="table table-hover table-bordered table-sm" style="width: 900px!important;">
                <thead class="thead-light sticky-top">
                <tr>
                    <th v-for="header in tableHeaders" :key="header.key" class="text-left">
                        {{ header.label }}
                    </th>
                    <th>Phiếu điểm</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, idx) in testHistoryData" :key="idx">
                    <td v-for="header in tableHeaders" :key="header.key">
                        <template v-if="header.key === 'result'">
                <span :class="getResultClass(row[header.key])">
                  {{ getResultText(row[header.key]) }}
                </span>
                        </template>
                        <template v-else>
                            {{ row[header.key] }}
                        </template>
                    </td>
                    <td>
                        <button
                            @click="openReportCard(row.order, row.lesson)"
                            class="btn btn-sm btn-outline-primary"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            v-if="row.check_mark_exam"
                            title="Phiếu điểm"
                        >
                            <i class="el-icon-notebook-2"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {DETAIL_EXAM_RETAKES} from "../../../../core/services/store/customer/customer.module";

export default {
    name: "TestHistory",
    props: {
        testHistoryData: {
            type: Array,
            default: () => []
        },
        test: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            tableHeaders: [
                {label: 'Lần kiểm tra', key: 'attempt'},
                {label: 'Kết quả', key: 'result'},
                {label: 'Overall', key: 'overall'},
                {label: 'Listening', key: 'listening'},
                {label: 'Speaking', key: 'speaking'},
                {label: 'Reading', key: 'reading'},
                {label: 'Writing', key: 'writing'},
                {label: 'Vocab', key: 'vocab'},
                {label: 'Reading & writing', key: 'reading_writing'},
                {label: 'Ngày cập nhật', key: 'updated_at'}
            ]
        }
    },
    methods: {
        getResultClass(result) {
            if (result === 'Pass' || result === 1) {
                return 'badge badge-green px-3 py-2';
            }
            if (result === 'Fail' || result === 0) {
                return 'badge badge-red px-3 py-2';
            }
            return 'badge badge-secondary px-3 py-2';
        },
        getResultText(result) {
            if (result === 1) return 'Pass';
            if (result === 0) return 'Fail';
            return result;
        },
        openReportCard(order, lesson)
        {
            this.$store.dispatch(DETAIL_EXAM_RETAKES, {
                user_id: this.$route.params.id,
                class_id: this.test?.class_id ?? '',
                order: order,
                lesson: lesson,
            }).then((res) => {
                let url = '';
                switch (this.test?.center_id) {
                    case 516:
                        url = 'https://exam.ieltsmentor.edu.vn/result?marking_exam_retake_id=' + res.data?.id + '&token=' + res.data?.uuid;
                        break;
                    case 295:
                        url = 'https://exam.ecoach.edu.vn/result?marking_exam_retake_id=' + res.data?.id + '&token=' + res.data?.uuid;
                        break;
                }
                window.open(url, '_blank');
            });
        }
    }
}
</script>

<style scoped>
.table {
    min-width: 800px;
}

.thead-light th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 10;
}
.badge-red {
  background: #BF0000;
  color: white;
}
.badge-green {
   background: #128300;
   color: white;
 }
</style>
